/* ===== The Pawlish Pro Trust Marquee - scoped rotating-message lifecycle ===== */
(function () {
  if (window.PawlishTrustMarquee && typeof window.PawlishTrustMarquee.init === 'function') {
    window.PawlishTrustMarquee.init(document);
    return;
  }

  var instances = new WeakMap();

  function getRoots(scope) {
    var roots = [];
    var context = scope && scope.querySelectorAll ? scope : document;

    if (context.matches && context.matches('[data-pro-trust-marquee]')) roots.push(context);

    context.querySelectorAll('[data-pro-trust-marquee]').forEach(function (root) {
      roots.push(root);
    });

    return roots;
  }

  function initRoot(root) {
    if (instances.has(root)) return;
    if (root.dataset.ptmMode !== 'center_rotating') return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ptm-item]'));
    if (items.length <= 1) return;

    var previousButton = root.querySelector('[data-ptm-prev]');
    var nextButton = root.querySelector('[data-ptm-next]');
    var interval = Number(root.dataset.ptmInterval) || 3500;
    var transition = Number(root.dataset.ptmTransition) || 350;
    var pauseOnHover = root.dataset.ptmPauseOnHover === 'true';
    var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var controller = new AbortController();
    var signal = controller.signal;
    var timer = null;
    var unlockTimer = null;
    var visibilityObserver = null;
    var firstFrame = null;
    var secondFrame = null;
    var locked = false;
    var isHovered = false;
    var isInViewport = !('IntersectionObserver' in window);
    var currentIndex = Math.max(
      0,
      items.findIndex(function (item) {
        return item.classList.contains('is-active');
      })
    );

    function clearAnimationWork() {
      if (firstFrame !== null) {
        window.cancelAnimationFrame(firstFrame);
        firstFrame = null;
      }

      if (secondFrame !== null) {
        window.cancelAnimationFrame(secondFrame);
        secondFrame = null;
      }

      if (unlockTimer !== null) {
        window.clearTimeout(unlockTimer);
        unlockTimer = null;
      }
    }

    function cleanTransitionClasses(item) {
      item.classList.remove('is-enter-right', 'is-enter-left', 'is-exit-left', 'is-exit-right');
    }

    function stop() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function canAutoplay() {
      if (!isInViewport) return false;
      if (document.hidden) return false;
      if (pauseOnHover && isHovered) return false;
      if (reducedMotion && reducedMotion.matches) return false;
      return true;
    }

    function start() {
      stop();
      if (!canAutoplay()) return;

      timer = window.setInterval(function () {
        showItem((currentIndex + 1) % items.length);
      }, interval);
    }

    function showItem(nextIndex, immediate) {
      if (nextIndex < 0 || nextIndex >= items.length) return;
      if (nextIndex === currentIndex) return;
      if (locked && !immediate) return;

      clearAnimationWork();

      var current = items[currentIndex];
      var next = items[nextIndex];

      items.forEach(function (item) {
        if (item !== current && item !== next) {
          item.classList.remove('is-active');
          cleanTransitionClasses(item);
        }
      });

      cleanTransitionClasses(current);
      cleanTransitionClasses(next);

      if (immediate || (reducedMotion && reducedMotion.matches)) {
        current.classList.remove('is-active');
        next.classList.add('is-active');
        currentIndex = nextIndex;
        locked = false;
        return;
      }

      locked = true;
      next.classList.add('is-enter-right');

      firstFrame = window.requestAnimationFrame(function () {
        firstFrame = null;
        secondFrame = window.requestAnimationFrame(function () {
          secondFrame = null;
          current.classList.add('is-exit-left');
          current.classList.remove('is-active');
          next.classList.remove('is-enter-right', 'is-enter-left');
          next.classList.add('is-active');
          currentIndex = nextIndex;

          unlockTimer = window.setTimeout(function () {
            unlockTimer = null;
            cleanTransitionClasses(current);
            current.classList.remove('is-active');
            locked = false;
          }, transition + 40);
        });
      });
    }

    function next() {
      showItem((currentIndex + 1) % items.length);
    }

    function previous() {
      showItem((currentIndex - 1 + items.length) % items.length);
    }

    function restartAfterInteraction() {
      start();
    }

    if (nextButton) {
      nextButton.addEventListener(
        'click',
        function () {
          next();
          restartAfterInteraction();
        },
        { signal: signal }
      );
    }

    if (previousButton) {
      previousButton.addEventListener(
        'click',
        function () {
          previous();
          restartAfterInteraction();
        },
        { signal: signal }
      );
    }

    if (pauseOnHover) {
      root.addEventListener(
        'mouseenter',
        function () {
          isHovered = true;
          stop();
        },
        { signal: signal }
      );
      root.addEventListener(
        'mouseleave',
        function () {
          isHovered = false;
          start();
        },
        { signal: signal }
      );
    }

    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.hidden) stop();
        else start();
      },
      { signal: signal }
    );

    if (reducedMotion) {
      var onReducedMotionChange = function () {
        if (reducedMotion.matches) stop();
        else start();
      };

      if (typeof reducedMotion.addEventListener === 'function') {
        reducedMotion.addEventListener('change', onReducedMotionChange, { signal: signal });
      } else if (typeof reducedMotion.addListener === 'function') {
        reducedMotion.addListener(onReducedMotionChange);
        signal.addEventListener(
          'abort',
          function () {
            reducedMotion.removeListener(onReducedMotionChange);
          },
          { once: true }
        );
      }
    }

    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var nextInViewport = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
          if (nextInViewport === isInViewport) return;

          isInViewport = nextInViewport;
          if (isInViewport) start();
          else stop();
        },
        { threshold: [0, 0.01] }
      );
      visibilityObserver.observe(root);
    }

    root.dataset.ptmReady = 'true';
    start();

    instances.set(root, {
      showBlock: function (blockId) {
        var targetIndex = items.findIndex(function (item) {
          return item.dataset.blockId === blockId;
        });

        if (targetIndex < 0) return;
        stop();
        showItem(targetIndex, true);
      },
      destroy: function () {
        stop();
        clearAnimationWork();
        visibilityObserver?.disconnect();
        visibilityObserver = null;
        controller.abort();
        locked = false;

        items.forEach(function (item, index) {
          cleanTransitionClasses(item);
          item.classList.toggle('is-active', index === currentIndex);
        });

        root.removeAttribute('data-ptm-ready');
      },
    });
  }

  function destroyRoot(root) {
    var instance = instances.get(root);
    if (!instance) return;

    instance.destroy();
    instances.delete(root);
  }

  function init(scope) {
    getRoots(scope).forEach(initRoot);
  }

  function destroyWithin(scope) {
    getRoots(scope).forEach(destroyRoot);
  }

  window.PawlishTrustMarquee = {
    init: init,
    destroyWithin: destroyWithin,
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target && event.target.closest ? event.target.closest('[data-pro-trust-marquee]') : null;
    if (!root) return;

    var instance = instances.get(root);
    if (!instance) {
      initRoot(root);
      instance = instances.get(root);
    }

    if (instance && event.detail && event.detail.blockId) {
      instance.showBlock(String(event.detail.blockId));
    }
  });
})();
